import { isFinite } from 'lodash'
import { ComponentPropsWithoutRef } from 'react'
import { useEffect, useState } from 'react'
import CurrencyInput from 'react-currency-input-field'

type MoneyFieldProps = {
  name?: string
  placeholder?: string
  value?: string | number
  onChange: (value: number) => void
  'data-testid'?: string
} & Omit<ComponentPropsWithoutRef<'input'>, 'onChange' | 'value' | 'step' | 'defaultValue'>

export const MoneyField = ({
  name,
  placeholder = '$0.00',
  value,
  onChange,
  'data-testid': dataTestId,
  ...props
}: MoneyFieldProps) => {
  const [val, setVal] = useState<string | number | undefined>(value)
  useEffect(() => {
    const num = parseFloat(val?.toString() ?? '')
    isFinite(num) && value != val && onChange(num)
  }, [val])
  return (
    <CurrencyInput
      allowDecimals
      name={name}
      value={val == 0 ? undefined : val}
      placeholder={placeholder}
      prefix="$"
      allowNegativeValue={false}
      step={1}
      autoFocus={true}
      data-testid={dataTestId}
      onValueChange={(e) => {
        setVal(e)
      }}
      {...props}
    />
  )
}
export default MoneyField
